import React from 'react';
import { ChevronUp, ChevronDown, X } from 'lucide-react';

const AgendaWidget = ({
  theme,
  isVisible,
  currentView,
  currentAgendaIndex,
  orderOfBusiness,
  agendaDisplayText,
  onPrevious,
  onNext,
  onAdvanceAgenda,
  onClose,
  canAdvance
}) => {
  if (!isVisible || currentView !== 'meeting' || !orderOfBusiness.length) {
    return null;
  }

  const cardClass = theme === 'dark' ? 'bg-gray-800 text-white' : 'bg-white';

  return (
    <div className="fixed bottom-20 right-4 z-40">
      <div className={`${cardClass} rounded-lg shadow-lg p-3 border-2 border-blue-200`}>
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <span className="text-xs font-medium text-blue-700">AGENDA:</span>
            <span className="text-sm font-medium text-blue-900">
              {currentAgendaIndex + 1}. {agendaDisplayText}
            </span>
          </div>
          <div className="flex space-x-1 ml-2">
            <button
              onClick={onPrevious}
              disabled={currentAgendaIndex === 0}
              className="text-blue-600 hover:text-blue-800 disabled:opacity-30"
            >
              <ChevronUp size={14} />
            </button>
            <button
              onClick={onNext}
              disabled={currentAgendaIndex >= orderOfBusiness.length - 1}
              className="text-blue-600 hover:text-blue-800 disabled:opacity-30"
            >
              <ChevronDown size={14} />
            </button>
            {canAdvance && (
              <button
                onClick={onAdvanceAgenda}
                className="px-2 py-1 bg-green-600 text-white rounded text-xs hover:bg-green-700"
                title="Mark as complete and advance"
              >
                ✓
              </button>
            )}
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 ml-1"
            >
              <X size={12} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgendaWidget;